import React, { useEffect, useState } from 'react'
import Api from '../../../../../services/Api'
import { INFTCardFormatted } from '../../../components/NFTCard/INFTCard'
import { IDefaultCard } from './IDefaultCard'
import { useGetBaseUri } from '../../../../../hooks/useYetiSwapNFTCollection'
import DefaultCardImage from '../components/DefaultCardImage/DefaultCardImage'
import BaseCard from '../../Base/Card/BaseCard'
import { getTokenUri } from '../../../../../services/NFTMarketPlace/Graphquery'

export default function DefaultCard(props: INFTCardFormatted) {
  const { tokenId, collection } = props
  const [tokenItem, setTokenItem] = useState<IDefaultCard | null>(null)
  const [tokenUri, setTokenUri] = useState('')
  const nftBaseUri = useGetBaseUri()

  const tokenName = tokenItem ? tokenItem.name : collection.name

  useEffect(() => {
    let isCancelled = false;
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => {
        if (!isCancelled) {
          setTokenUri(res)
        }
      })
    }
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => {
        if (!isCancelled) {
          setTokenItem(tokenResult)
        }
      })
    }
    return () => {
      isCancelled = true;
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  function getImage() {
    return (
      <DefaultCardImage item={tokenItem} baseURI={nftBaseUri} isCard={true} />
    )
  }

  return (
    <BaseCard tokenName={tokenName} {...props}>
      {getImage()}
    </BaseCard>
  )
}
